import React from 'react'
import { Button } from '@mui/material'
import { PlayArrow } from '@mui/icons-material'

interface Props {
  text?: string
  onClick: () => void
  variant?: 'contained' | 'outlined'
}

const ClickToPlayButton: React.FC<Props> = ({ text, onClick, variant }) => {
  return (
    <Button
      onClick={onClick}
      startIcon={<PlayArrow />}
      variant={variant}
      fullWidth
    >
      {text}
    </Button>
  )
}

export default ClickToPlayButton
